export default {
	"capacityPool": {
		"partnerName": "Belong to",
		"plateType": "license plate type",
		"hasGps": "is there a gps",
		"capacityInfo": "capacity information",
		"addCapacity": "new capacity",
		"routeType": "line type"
	},
	"motorcade": {
		"name": "fleet name",
		"driverNum": "number of drivers",
		"vehicleNum": "number of vehicles",
		"partnerName": "carrier partner",
		"capatainName": "fleet leader",
		"addMotorcade": "create new fleet",
		"motorcadeInfo": "fleet information",
		"requirement": "vehicle maintenance requirements",
		"depreciation": "depreciation requirements",
		"maintenance": "maintenance requirements",
		"insurance": "insurance requirements",
		"vehicleCertificate": "vehicle document requirements",
		"pictureAttachment": "photo attachment",
		"certificateRequirement": "driver id requirements",
		"driverCertificateIsRequired": "driver id requiredname required",
		"vehicleCertificateisRequired": "vehicle certificate required name is required",
		"certificateNameNorNull": "vehicle certificate requirements the certificate name cannot be empty!",
		"dricerNameNorNull": "the driver's certificate requires that the name of the certificate cannot be empty!"
	},
	"ourdriver": {
		"drivingAgeMonth": "driving age range",
		"driverName": "driver name",
		"drivingAge": "driving age",
		"zeroMonth": "0 months",
		"driverLicenseType": "type of driver's license",
		"defaultVehiclePlate": "default vehicle",
		"baseWage": "basic wage",
		"newDriver": "create new driver",
		"licenseDate": "date of initial receipt",
		"defaultVehicleNoTips": "please select the license plate number",
		"score": "driver's license score",
		"importFailed": "import failed",
		"driverInfo": "driver information",
		"startAndEndDateTips": "the expiration date of the certificate must be greater than the expiration date of the certificate"
	},
	"ourvehicle": {
		"refuelRecord": "refueling/charging records",
		"vehicleAge": "car age",
		"vehicleValue": "original value",
		"netValue": "net worth",
		"equipmentPosition": "device positioning",
		"newVehicle": "new vehicle",
		"plateLicenseColor": "license plate color",
		"vehicleRegistDate": "vehicle registration date",
		"gpsFee": "gps annual cost",
		"importCar": "import vehicle",
		"importRefuel": "import fuel record",
		"inputCarNoTips": "please enter the correct license plate number",
		"carNoOrVehicleTypeCodeTips": "license plate number, model is not fully passed to the background",
		"year": "year",
		"month": "mileage month",
		"aYear": "1 year",
		"noLocationInfo": "no location information yet",
		"certificateAdmin": "document management",
		"reach": "to",
		"certificateFee": "annual inspection amount",
		"fuelPerson": "refueling/charging",
		"fuelDate": "refuel/charge date",
		"fuelVolumn": "refueling/charging capacity (liter/degree)",
		"oilType": "oil type",
		"fuelMoney": "refueling/charging amount",
		"payType": "payment method",
		"maintenanManage": "maintenance management",
		"maintenancePlan": "maintenance plan",
		"nextMaintenanceMileage": "next maintenance mileage",
		"nextMaintenanceTime": "next maintenance date",
		"maintenancePeriod": "maintenance cycle",
		"upkeepCost": "total maintenance fee",
		"repairCost": "total maintenance cost",
		"repairAndUpkeepCost": "total maintenance",
		"addMaintenanManage": "maintenance records",
		"maintenanceType": "type",
		"maintenanceDt": "maintenance date",
		"remark": "describe",
		"amount": "maintenance amount",
		"repairMan": "repairer",
		"depreciationOfAssets": "depreciation of assets",
		"premiumPeriod": "scrap period (month)",
		"salvage": "residual rate",
		"inputRangeTips": "please enter a number from 0 to 1.0000",
		"depreciationValue": "accumulated depreciation",
		"residualValue": "residual value",
		"insuranceLog": "insurance records",
		"insuranceType": "type of insurance",
		"premium": "insurance fee",
		"mileageLog": "mileage record",
		"mileage": "total mileage",
		"currentMonthMileage": "mileage for the month",
		"monthMileageInfo": "monthly mileage",
		"monthMileage": "mileage (km)",
		"totalMileage": "mileage at the end of the month (km)",
		"mileageJournal": "mileage log",
		"methodCode": "calculation method",
		"distance": "mileage (km)",
		"violationRecords": "violation record",
		"violationContent": "illegal content",
		"violationAddress": "place",
		"violationTime": "illegal time",
		"pointsDeducted": "deduction",
		"penalty": "fine",
		"driverName": "illegal driver",
		"checkPersonName": "confirmor",
		"regularLine": "regular route",
		"line": "line",
		"capacityPool": "capacity pool",
		"certificateInfo": "identity informaiton",
		"violationInfo": "illegal information",
		"curingInfo": "maintenance information",
		"max500": "less than 500 words",
		"pleaseAddAttachments": "please add attachment",
		"certificateFeeTips": "the annual inspection amount is incorrectly entered, please enter a value between 0 and 9999999.99 with two decimal places.",
		"isTrunkTips": "when the line type is trunk line, the origin city and destination city cannot be the same!",
		"currentMileageTips": "the current mileage cannot be greater than the total mileage",
		"dateTips": "expiration date must be greater than effective date",
		"oldValueInputError": "the original value is incorrectly entered, please enter a value between 0 and 9999999.99 with two decimal places.",
		"gpsFeeTips": "gps annual fee input error, please input the value between 0~9999999.99, keep two decimal places",
		"premiumPeriodTips": "the expiration date is incorrectly entered, please enter an integer between 0 and 1000",
		"salvageTips": "residual value input error, please enter a decimal or integer between 0 and 1, and keep four decimal places",
		"maintenancePeriodTips": "maintenance cycle input error, please input a positive integer"
	},
	"partner": {
		"quotationTemplate": "rate card template",
		"businessRelations": "relation",
		"partnerType": "online or not",
		"offer": "must have a rate card",
		"nLike": "partner name\\short name\\code",
		"partnerName": "name",
		"billingObject": "billing party",
		"comments": "business description",
		"partnerCode": "no #",
		"billingTips": "please select a billing party",
		"receiptDtSize": "receipt time",
		"receiptDt": "cut-off date of the month",
		"outerCode": "external code",
		"outerSourceCode": "external source",
		"companyGroup": "affiliated company",
		"day": "day",
		"number": "no #",
		"batchWorking": "bulk delivery is allowed",
		"belongToUser": "belong to user",
		"heIsyours": "he is your",
		"heUseThisPlatform": "the company also uses this platform",
		"heNotUseThisPlatform": "the company not use this platform",
		"partnerNameTips": "enter company name/abbreviation",
		"partnerCodeTips": "please enter the code (maximum 20 characters)",
		"shortNameTips": "please enter abbreviation (maximum 50 characters)",
		"salesman": "salesman",
		"existential": "existed.",
		"application": "apply",
		"saveAddNext": "please fill in and save the successful contact information before adding the next one",
		"partnerCodeNotNullTips": "number cannot be empty.",
		"acceptTips": "are you sure to accept?",
		"partnerInvitedTips": "Please copy the invitation address to your partner",
		"copyLink": "copy Link",
		"inviteTips": "invite him to the platform"
	},
	"product": {
		"productNameAndCode": "Group Name\\Group Short Name\\Group Code",
		"superiorProduct": "Superior Product",
		"level": "Level",
		"createChild": "Create a New Sub-Product",
		"addNewProduct": "Create New Surcharge/Discount Group",
		"groupCode": "Group Code",
		"groupName": "Group Name",
		"groupShortName": "Group Short Name",
		"enterGroupCode": "Enter Group Code",
		"enterGroupName": "Enter Group Name",
		"enterGroupShortName": "Enter Group Short Name",
		"rangeValueMustBe": "range value must be",
		"numberBetween": "between the numbers!",
		"maxAndminTips": "【upper limit】must be greater than or equal to 【lower limit】!",
		"defaultValueWithinRange": "the default value must be a number in the range of values!",
		"commaErrorGroupCode": "Cannot input special character as commas (“ , “) in Group code",
		"createSuccess": "Create Surcharge/Discount Group successfully",
		"groupCodeOrNameExists": "Group Code or Group Name already exists",
	},
	"serviceItem": {
		"createNew": "Create New Surcharge/Discount Items",
		"itemCode": "Item code",
		"itemName": "Item name",
		"step": "Step",
		"selectStep": "Select Step",
		"commaErrorItemCode": "Cannot input special character as commas (“ , “) in Item code",
		"createSuccess": "Create Surcharge/Discount Items successfully",
		"enterShortName": "Enter Short Name",
		"enterItemCode": "Enter Item code",
		"enterItemName": "Enter Item name",
		"selectBelongTo": "Select Belong to",
		"itemCodeOrNameExists": "Item Code or Item Name already exists",
	},
	"project": {
		"nameOrNoTips": "project name\\code",
		"projectName": "Name",
		"serviceContent": "Surcharge/Discount Item",
		"addService": "Add Surcharge/Discount Item",
		"essentialService": "essential services",
		"pleaseSelectMotherboard": "Please select a template for quotation",
		"orderContent": "document content",
		"addNewItem": "new project",
		"sureAgree": "are you sure to agree?",
		"agreed": "approved!",
		"suspendTips": "are you sure to pause?",
		"toBeConfirmedTips": "this online project has been initiated, waiting for the other party to confirm!",
		"inputTips": "please enter a number greater than 0 with up to two decimal places!",
		"coldStorage": "refrigeration",
		"minWeightTips": "the minimum weight is a number between 0.001 and 99999.999!",
		"maxWeightTips": "the maximum weight is a number between 0.001 and 999999.999!",
		"minVolumeTips": "the minimum volume is a number between 0.001 and 999.999!",
		"maxVolumeTips": "the maximum volume is a number between 0.001 and 999.999!",
		"minGoodsValueTips": "the minimum value of the declared value is a number between 0.00 and 9999999.99!",
		"maxGoodsValueTips": "the maximum value of the declared value is a number between 0.00 and 9999999.99!",
		"minPackingQtyTips": "the minimum number of packages is a number between 1 and 999999999!",
		"maxPackingQtyTips": "the maximum number of packages is a number between 1 and 999999999!",
		"maxDistributionOrder": "maximum delivery order",
		"betweenMaxiAndMini": "the default value must be a number between the maximum and minimum values!",
		"areYouSureToSave": "are you sure to save?",
		"noMotherboardInfo": "unrecognized template information.",
		"multipleMotherboardInfo": "duplicate template information",
		"noServiceInfo": "unrecognized service information.",
		"multipleServiceInfo": "duplicate service information",
		"duplicateSurchargeDiscount": "Surcharge/Discount Item Name is already existed",
	},
	"site": {
		"stationNoOrName": "site code/name",
		"ownSite": "own site",
		"sharedSite": "shared site",
		"stationOwn": "shared properties",
		"locationStatus": "map positioning",
		"stationNo": "Site code",
		"stationName": "Site name",
		"province": "province",
		"city": "city",
		"district": "county (district)",
		"siteStaff": "site staff",
		"operators": "operators",
		"pleaseSelectOperators": "please select a worker",
		"addSite": "create new site",
		"pleaseSiteName": "please enter a site name",
		"stationTypeTips": "please select a site type",
		"entrepotCreate": "Is it a distribution center",
		"channelNum": "Number of docks",
		"pleaseInputChannelNum": "please enter the number of docks",
		"pleaseInputSiteNo": "please enter site code",
		"priority": "Priority",
		"loadSpeed": "Loading and unloading speed",
		"loadSpeedUnit": "loading and unloading speed (kg/min)",
		"workTime": "Working time window",
		"limitLength": "Maximum model length",
		"limitLengthUnit": "maximum model length (m)",
		"checkTime": "Handover time (minutes)",
		"locked": "Lock or not",
		"addrRange": "Location range (M)",
		"stationAddress": "Address",
		"stationAddressPlaceholder": "Please select address",
		"yes": "have",
		"no": "none",
		"salesman": "salesman",
		"alreadyExists": "existed",
		"has": "yes",
		"addressChange": "the address information has been changed, please [relocate] before submitting!",
		"location": "Location",
		"reposition": "re-locate",
		"inputAddressTips": "please fill in the province, city and address information!",
		"failedToLocate": "positioning failed, please confirm the address information and try again!"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/our/our.js